import React, { useCallback, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core'
import { useInsertClientTagOption, useModifyClientTagOption } from '../../../../../api/dataMaintenance'
import SydModal from '../../../../commonDesign/SydModal'
import SydLabel from '../../../../commonDesign/SydLabel'
import SydInput from '../../../../commonDesign/SydInput'
import Loading from '../../../../molecules/Loading'
import InputColorPicker from '../../../../molecules/InputColorPicker'
import SaveCancelButtons from '../../../../molecules/SaveCancelButtons'
import ErrorDisplay from '../../../../molecules/ErrorDisplay'

export const modalStyles = makeStyles((theme) => ({
  root: {
    height: '25rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  inputRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  buttonRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center'
  }
}))
export const TagModal = ({ open, close, tag, groupTypeId }) => {
  const classes = modalStyles()
  const { mutateAsync: modifyTagOption, isLoading, isError, error } = useModifyClientTagOption()
  const { mutateAsync: insertTagOption, isLoading: insertLoading, isError: insertIsError, error: insertError } = useInsertClientTagOption()
  const onSubmit = useCallback(async (data) => {
    let result
    const command = {
      groupId: data.groupId || 0,
      groupTypeId: parseInt(groupTypeId) || groupTypeId,
      longName: data.displayName || '',
      shortName: data.shortName || '',
      colorField: data.color || '#FFFFFF',
      ordinal: (data.ordinal == null || data.ordinal === '') ? 0 : data.ordinal,
      description: data.description || ''
    }
    if (command.groupId === 0) {
      result = await insertTagOption(command)
    } else {
      result = await modifyTagOption(command)
    }
    if (result.success) {
      close()
    }
  }, [modifyTagOption, insertTagOption, groupTypeId, close])
  const form = useForm({
    mode: 'onChange',
    defaultValues: {
      displayName: tag?.longName || '',
      color: tag?.colorField || '#FFFFFF',
      ordinal: tag?.ordinal || 0,
      description: tag?.description || '',
      shortName: tag?.shortName || '',
      groupId: tag?.groupId || 0
    }
  })
  useEffect(() => {
    if (tag) {
      form.reset({
        displayName: tag?.longName || '',
        color: tag?.colorField || '#FFFFFF',
        ordinal: tag?.ordinal || 0,
        description: tag?.description || '',
        shortName: tag?.shortName || '',
        groupId: tag?.groupId || 0
      })
    }
  }, [tag, form])
  if (!tag) {
    return null
  }
  return (
    <div>
      <SydModal size='medium' open={open} title='Tag Option Details' onClose={close}>
        <form>
          <div className={classes.root}>
            <Controller
              name='displayName'
              control={form.control}
              render={(f) => (
                <SydLabel label='Display Name' required>
                  <div className={classes.inputRow}>
                    <SydInput
                      {...f.field}
                    />
                    {
                      isLoading && <Loading isLoading={isLoading} isError={isError} error={error} />
                    }
                    {
                      insertLoading && <Loading isLoading={insertLoading} isError={insertIsError} error={insertError} />
                    }
                  </div>
                </SydLabel>
              )}
            />
            <div className={classes.inputRow}>
              <Controller
                name='shortName'
                control={form.control}
                render={(f) => (
                  <SydLabel label='Code' required>
                    <SydInput {...f.field} />
                  </SydLabel>
                )}
              />
              <Controller
                name='description'
                control={form.control}
                render={(f) => (
                  <SydLabel label='Description'>
                    <SydInput {...f.field} />
                  </SydLabel>
                )}
              />
            </div>
            <div className={classes.inputRow}>
              <Controller
                name='color'
                control={form.control}
                render={(f) => (
                  <SydLabel label='Color'>
                    <div>
                      <InputColorPicker
                        InputProps={{ disableUnderline: true }}
                        value={f.field.value}
                        onChange={f.field.onChange}
                        disableAlpha
                      />
                    </div>
                  </SydLabel>
                )}
              />
              <Controller
                name='ordinal'
                control={form.control}
                render={(f) => (
                  <SydLabel label='Ordinal'>
                    <SydInput {...f.field} />
                  </SydLabel>
                )}
              />
            </div>
            <div className={classes.inputRow}>
              <Controller
                name='groupId'
                control={form.control}
                render={(f) => (
                  <SydLabel label='Group' style={{ display: 'none' }}>
                    <SydInput {...f.field} />
                  </SydLabel>
                )}
              />
            </div>

          </div>
          <div className={classes.buttonRow}>
            <SaveCancelButtons onSave={form.handleSubmit(onSubmit)} onCancel={close} />
          </div>
          {isError && (
            <ErrorDisplay isError={isError} error={error} />
          )}
          {insertIsError && (
            <ErrorDisplay isError={insertIsError} error={insertError} />
          )}
        </form>
      </SydModal>
    </div>
  )
}

TagModal.propTypes = {
  open: PropTypes.bool,
  close: PropTypes.func,
  tag: PropTypes.object,
  groupTypeId: PropTypes.number
}
